import { useLocation, useParams } from 'react-router-dom'
import { useAdSupplierById } from '@/hooks/useAdSupplierById'
import { PageHeader } from '@/components/PageHeader'
import AdSupplierInfo from './AdSupplierInfo'

export default function AdSupplierPage() {
  const location = useLocation()
  const params = useParams()
  // 路徑可能是 /admin/ad-supplier/create、/provider/:id/ad-supplier/create、或 /ad-supplier/:supplier_id/info
  const isCreateMode = location.pathname.endsWith('/ad-supplier/create')
  const supplierId = isCreateMode ? undefined : params.supplier_id
  const { adSupplier, isLoading } = useAdSupplierById(supplierId)

  const headerLevel = isCreateMode ? 'page' : 'section'
  const title = isCreateMode ? '新增供應商' : '供應商資訊'
  const description = isCreateMode ? '建立新的供應商資訊' : '管理供應商資訊和人員'

  return (
    <div className="space-y-6">
      <PageHeader title={title} description={description} level={headerLevel} />

      <AdSupplierInfo
        adSupplier={adSupplier}
        isLoading={isLoading}
        mode={isCreateMode ? 'create' : 'edit'}
      />
    </div>
  )
}
